import React, { createContext, useState, useCallback } from "react";

export interface SidebarItem {
  id: string;
  component: React.ReactNode;
  position?: "top" | "bottom"; // top: after ProfileCard, bottom: at the end
}

interface SidebarContextType {
  items: SidebarItem[];
  addItem: (item: SidebarItem) => void;
  removeItem: (id: string) => void;
  clearAll: () => void;
}

export const SidebarContext = createContext<SidebarContextType | undefined>(
  undefined,
);

interface SidebarProviderProps {
  children: React.ReactNode;
}

export const SidebarProvider: React.FC<SidebarProviderProps> = ({
  children,
}) => {
  const [items, setItems] = useState<SidebarItem[]>([]);

  const addItem = useCallback((item: SidebarItem) => {
    setItems((prev) => {
      // Prevent duplicates
      if (prev.some((i) => i.id === item.id)) {
        return prev;
      }
      return [...prev, item];
    });
  }, []);

  const removeItem = useCallback((id: string) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
  }, []);

  const clearAll = useCallback(() => {
    setItems([]);
  }, []);

  return (
    <SidebarContext.Provider value={{ items, addItem, removeItem, clearAll }}>
      {children}
    </SidebarContext.Provider>
  );
};
